// Segment 3 — The Briefing
import AccordionBlock from '@/components/AccordionBlock';

const GLOSSARY = [
  { term: 'LLM', def: 'Large Language Model — the AI trained on vast text; the engine behind Claude, GPT, Gemini.' },
  { term: 'Generative AI', def: 'AI that creates new content (text, images, code, audio) in response to a prompt.' },
  { term: 'Prompt', def: 'Your text instruction to the AI — the quality of input determines the quality of output.' },
  { term: 'Context', def: 'Background you feed the AI before asking it to do something; more context = better output.' },
  { term: 'Artifact', def: 'Any output the AI produces — a draft, a policy, a table, a script, a slide deck.' },
  { term: 'Project', def: 'A workspace in Claude that holds persistent context across multiple conversations.' },
  { term: 'Agent', def: 'An AI that can take actions (browse, run code, call APIs) rather than just generate text.' },
  { term: 'Generalist vs Specialist', def: 'Generalist tools do many tasks well; specialist tools do one task exceptionally.' },
];

const Segment3 = () => (
  <div>
    <h1 className="text-4xl md:text-5xl font-bold text-ink mb-6 leading-tight">The Briefing</h1>

    <p className="text-2xl md:text-3xl text-ink mb-12">
      Eyes up front — V has this one.
    </p>

    <div>
      <p className="text-xs text-ink-muted mb-3 flex items-center gap-1.5 font-medium">
        <span>☝</span> Click each arrow to reveal content
      </p>
      <div className="space-y-2 max-w-2xl" data-testid="glossary-list">
        {GLOSSARY.map((item) => (
          <AccordionBlock key={item.term} title={item.term}>
            <p className="text-sm text-ink-secondary leading-relaxed pt-1">{item.def}</p>
          </AccordionBlock>
        ))}
      </div>
    </div>
  </div>
);

export default Segment3;
